import { apiGet, planningPath } from './PlanningApiClient';

export interface Venue {
  id: string;
  name: string;
  address?: string;
  capacity?: number;
}

export async function getVenues(): Promise<Venue[]> {
  const data = await apiGet<{ venues: Venue[] }>(planningPath('/venues'));
  return data.venues || [];
}
